export default __webpack_public_path__ + "static/media/cableyellow-cut.568307da.png";